import { useEffect, useState, useCallback } from "react";
import { Button } from "../ui/button";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../lib/api";
import { TaskBoard } from "./TaskBoard";
import { NewTaskDialog } from "./NewTaskDialog";
import { TaskDetailPanel } from "./TaskDetailPanel";

// Pestaña "Tareas" en la ficha de iniciativa — spec §pestaña de tareas en la
// ficha: tarjetas filtradas a esta iniciativa + botón "Nueva tarea" ya
// pre-rellenado con el initiative_id.
export function InitiativeTasksTab({ initiativeId, initiativeName }) {
  const { token } = useAuth();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newOpen, setNewOpen] = useState(false);
  const [detailTaskId, setDetailTaskId] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await api.listTasks(token, { initiative_id: initiativeId });
      setTasks(r.items || []);
    } catch (e) {
      toast.error("No se pudieron cargar las tareas de la iniciativa");
    } finally {
      setLoading(false);
    }
  }, [token, initiativeId]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-4" data-testid="initiative-tasks-tab">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">{tasks.length} tarea(s) vinculada(s) a esta iniciativa</p>
        <Button size="sm" onClick={() => setNewOpen(true)} className="gap-1.5" data-testid="initiative-tasks-new-button">
          <Plus className="w-4 h-4" />Nueva tarea
        </Button>
      </div>
      {loading ? (
        <p className="text-sm text-muted-foreground">Cargando...</p>
      ) : tasks.length === 0 ? (
        <p className="text-sm text-muted-foreground italic">Sin tareas todavía.</p>
      ) : (
        <TaskBoard tasks={tasks} onOpenTask={setDetailTaskId} onChanged={load} />
      )}
      <NewTaskDialog open={newOpen} onOpenChange={setNewOpen} initiativeId={initiativeId} initiativeName={initiativeName} onCreated={load} />
      <TaskDetailPanel taskId={detailTaskId} open={!!detailTaskId} onOpenChange={(o) => !o && setDetailTaskId(null)} onChanged={load} />
    </div>
  );
}
